import {Injectable} from '@angular/core';
import {Subject, Subscription} from 'rxjs';

interface EventWithContent<T = any> {
  name: string;
  content?: T;
}

@Injectable({providedIn: 'root'})
export class JhiEventManager {
  private channels: {[key: string]: Subject<any>} = {};

  broadcast(event: EventWithContent): void {
    if (!this.channels[event.name]) {
      this.channels[event.name] = new Subject<any>();
    }
    this.channels[event.name].next(event.content);
  }

  subscribe(eventName: string, callback: (content: any) => void): Subscription {
    if (!this.channels[eventName]) {
      this.channels[eventName] = new Subject<any>();
    }
    return this.channels[eventName].subscribe(callback);
  }

  destroy(subscriber: Subscription): void {
    subscriber.unsubscribe();
  }
}
